import { render, staticRenderFns } from "./confirmOTP.vue?vue&type=template&id=5e5b69d3&scoped=true"
import script from "./confirmOTP.vue?vue&type=script&lang=js"
export * from "./confirmOTP.vue?vue&type=script&lang=js"
import style0 from "./confirmOTP.vue?vue&type=style&index=0&id=5e5b69d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5b69d3",
  null
  
)

export default component.exports